import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {QUERY_KEYS} from '@/queryClient.ts'
import {httpPhotographersMe} from '@features/user/http/user.http.ts'
import {parseAxiosPromise} from '@/axiosInstance'
import {captureException} from '@sentry/react'
import {z} from 'zod'
import {PhotographerUser} from '../types'

const PhotographersMeResponseSchema = z.object({
    user: PhotographerUser
})

type PhotographersMeResponseSchema = z.infer<typeof PhotographersMeResponseSchema>

export const usePhotographersMe = (
    options?: Omit<
        UseQueryOptions<PhotographersMeResponseSchema, unknown, PhotographersMeResponseSchema>,
        'queryFn' | 'queryKey'
    >
) => {
    return useQuery({
        queryKey: [QUERY_KEYS.PHOTOGRAPHERS_ME],
        queryFn: () =>
            parseAxiosPromise({
                axiosPromise: httpPhotographersMe(),
                responseShape: PhotographersMeResponseSchema,
                onZodError: captureException
            }),
        ...options
    })
}
